import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'hongkongprotests',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './hongkongprotests.component.html',
  styleUrl: './hongkongprotests.component.scss',
})
export class HongkongprotestsComponent {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = 'Hong Kong Protests';

  ngOnInit() {
    this.titleService.setTitle('Hong Kong Protests');
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Hong Kong Protests',
    });
    this.pageTitleImg = 'assets/images/w2c/page-header/faqs.jpg';
  }
}
